"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export const URL_COUPON_STORAGE_KEY = "rh_url_coupon";

/**
 * Remembers a ?coupon= code from any landing URL (e.g. the invoice payment page link to "/")
 * so the funnel can apply it on the reviews step, even when the search navigation drops the param.
 */
export function CouponParamCapture() {
  const params = useSearchParams();

  useEffect(() => {
    const coupon = params.get("coupon")?.trim();
    if (!coupon) return;
    try {
      sessionStorage.setItem(URL_COUPON_STORAGE_KEY, coupon);
    } catch {
      // Storage can be unavailable (private mode); the URL param still works on funnel pages.
    }
  }, [params]);

  return null;
}
